import {useEffect} from 'react';
import './styles.css'


import aos from "aos";
import 'aos/dist/aos.css'

export default function SkillsIcons ({stack, names}) {

    useEffect(() => {
        aos.init({duration: 2000})
    })

    return (
        <div data-aos="fade-left" className="items-skills">
            {
                names.map((el, i) => (
                    // <Animator key={el + i} animation={Fade()}>
                    <img 
                        key={el + i}
                        src={`${process.env.PUBLIC_URL}/img/${stack}/${el}.png`} 
                        alt={el}
                    />
                    // </Animator>
                ))
            }
            {/* <Animator key={stack} animation={batch(Fade())}> */}
                <h3 className={stack}>
                    {
                        stack !== "db"
                        ? `${stack[0].toUpperCase().concat(stack.slice(1))}-End`
                        : "DataBases" 
                    }
                </h3>
            {/* </Animator> */}
        </div>
    )
}